'use strict';

// load Bootstrap's JS
require('bootstrap-sass');

// first initialize our app component
require('./components/app');

// load Basecoat components
require('./components/accordion');
require('./components/desktop-menu');
require('./components/site-header');
require('./components/mobile-menu');
require('./components/dropdown');
require('./components/checkbox');
require('./components/radio');
require('./components/datetime-picker');
require('./components/password-toggle');
require('./components/tooltip');
require('./components/scrollspy');
require('./components/modal');
require('./components/toast');
require('./components/notification');
require('./components/tab');
require('./components/scrollbar');
require('./components/progress-step');
require('./components/popover');
require('./components/loader');
require('./components/site-search');



//////////////////
// WEBPACK FOOTER
// ./src/core/js/main.js
// module id = 28
// module chunks = 0